/**
 * @fileoverview PlatformThemeProvider renders a BeaconThemeProvider component with the correct
 * theme based on the feature flipper state for the customer.
 */
import React from "react";

import BeaconThemeProvider from "@braze/beacon-styling";
import { rebrandTheme } from "@braze/beacon-theme";

import type { PlatformThemeProviderProps } from "./types";

export const PlatformThemeProvider = ({ children }: PlatformThemeProviderProps): React.ReactElement => {
  return <BeaconThemeProvider theme={rebrandTheme}>{children}</BeaconThemeProvider>;
};
